import { render, staticRenderFns } from "./qualification-result.vue?vue&type=template&id=36552ee7&scoped=true"
import script from "./qualification-result.vue?vue&type=script&lang=js"
export * from "./qualification-result.vue?vue&type=script&lang=js"
import style0 from "./qualification-result.vue?vue&type=style&index=0&id=36552ee7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36552ee7",
  null
  
)

export default component.exports